import { useCallback } from 'react'
import { DomainName } from 'types/Marketing/SGLLinkGenerator.types'
import { useApiClient } from 'utils/api/ApiClient'
import { ClientAreaApiClient } from 'utils/api/clientAreaApi'
import { useFetchOne } from 'utils/api/useFetch'

interface PublicDomainsFetch {
  addPublicDomains?: DomainName[]
  editPublicDomains?: DomainName[]
  isLoading: boolean
}

export const usePublicDomainsFetch = (
  addCompanyId: number | undefined,
  editCompanyId?: number | undefined
): PublicDomainsFetch => {
  const apiClient = useApiClient(ClientAreaApiClient)

  const getDomains = (companyId: string | undefined) => {
    if (companyId && companyId !== '0') {
      return apiClient.getDomainNames({ companyId })
    }
    return Promise.resolve([])
  }
  const addPublicDomainCallback = useCallback(
    () => getDomains(addCompanyId?.toString()),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [addCompanyId]
  )

  const { data: addPublicDomains, isLoading } = useFetchOne(addPublicDomainCallback)

  const editPublicDomainCallback = useCallback(
    () => getDomains(editCompanyId?.toString()),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [editCompanyId]
  )

  const { data: editPublicDomains } = useFetchOne(editPublicDomainCallback)

  return { addPublicDomains, editPublicDomains, isLoading }
}
